<template>
  <!--設定 login modal-->
  <i-modal v-model="_modal" :title="modalTitle" class="modal-password" footer-hide @on-visible-change="onVisibleChange">
    <div class="modal-password__container">
      <!-- パスワードが設定されていた場合 -->
      <div v-if="settingFlg === 1" class="">
        <i-tabs v-model="activeTab" value="auth" size="small">
          <i-tab-pane label="認証" name="auth">
            <i-form
              label-position="top"
              style="margin-bottom: 0; min-height: 140px;"
              @submit.native.prevent="onClickLoginModalOk"
            >
              <i-form-item label="パスワード">
                <i-input v-model="inputPassword" type="password" placeholder size="large" />
                <p style="height: 15px;">
                  <transition name="fade">
                    <span v-show="validatePassword !== ''" class="error">
                      {{ validatePassword }}
                    </span>
                  </transition>
                </p>
              </i-form-item>
            </i-form>
            <div class="btn">
              <i-button style="margin-right: 4px;" @click="onClickLoginModalCancel">キャンセル</i-button>
              <i-button type="primary" @click="onClickLoginModalOk">認証</i-button>
            </div>
          </i-tab-pane>
          <i-tab-pane label="パスワード変更" name="change">
            <i-form
              label-position="top"
              style="margin-bottom: 0; min-height: 140px;"
              @submit.native.prevent="onClickChange"
            >
              <i-form-item label="現在のパスワード">
                <i-input v-model="inputOldPassword" type="password" placeholder size="large" />
              </i-form-item>
              <i-form-item label="新しいパスワード">
                <i-input v-model="inputNewPassword" type="password" placeholder size="large" />
                <p style="height: 15px;">
                  <transition name="fade">
                    <span v-show="validateEditPassword !== ''" class="error">
                      {{ validateEditPassword }}
                    </span>
                  </transition>
                </p>
              </i-form-item>
            </i-form>
            <div class="btn">
              <i-button style="margin-right: 4px;" @click="onClickLoginModalCancel">キャンセル</i-button>
              <i-button type="primary" @click="onClickChange">変更</i-button>
            </div>
          </i-tab-pane>
        </i-tabs>
      </div>

      <!-- パスワードが設定されていない場合 -->
      <div v-else class="regist">
        <p class="text">パスワードを登録します。</p>
        <i-form label-position="top" style="margin-bottom: 0" @submit.native.prevent="onClickRegist">
          <i-form-item label="パスワード">
            <i-input v-model="inputRegistPassword" type="password" placeholder size="large" />
            <p style="height: 15px;">
              <transition name="fade">
                <span v-show="validateRegistPassword !== ''" class="error">
                  {{ validateRegistPassword }}
                </span>
              </transition>
            </p>
          </i-form-item>
        </i-form>
        <div class="btn">
          <i-button style="margin-right: 4px;" @click="onClickLoginModalCancel">キャンセル</i-button>
          <i-button type="primary" @click="onClickRegist">登録</i-button>
        </div>
      </div>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button, Tabs, TabPane, Form, FormItem, Input } from 'view-design'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-tabs': Tabs,
    'i-tab-pane': TabPane,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-input': Input,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
      requied: true,
    },
  },
  data() {
    return {
      inputPassword: '',
      inputOldPassword: '',
      inputNewPassword: '',
      inputRegistPassword: '',
      validatePassword: '',
      validateEditPassword: '',
      validateRegistPassword: '',
      settingFlg: 1,
      activeTab: 'auth',
    }
  },
  computed: {
    _modal: {
      get() {
        return this.modal
      },
      set(val) {
        this.$emit('update:modal', val)
      },
    },
    modalTitle() {
      return this.settingFlg ? '認証' : '認証設定'
    },
  },
  methods: {
    // モーダル開閉時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // パスワード設定チェック
        this.checkSetPassword()
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // パスワード設定状況取得処理
    checkSetPassword() {
      this.settingFlg = this.$store.getters['User/getUserHasChiefPassword']
    },
    // モーダル 認証ボタン クリック処理
    async onClickLoginModalOk() {
      this.validatePassword = ''
      if (this.inputPassword === '') this.validatePassword = 'パスワードを入力してください。'
      if (this.validatePassword !== '') return
      // API ログイン認証
      this.authPassword(this.inputPassword)
    },
    // パスワード認証処理
    async authPassword(password) {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.authPassword(password)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.body.result) {
              this._modal = false
              this.$emit('authentication')
            } else {
              this.validatePassword = resp.data.body.message
            }
          } else if (resp.status === 400) {
            this.validatePassword = resp.data.body.message
          } else {
            alert('パスワード認証に失敗しました。')
            this._modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('パスワード認証に失敗しました。')
          this._modal = false
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // モーダル キャンセルボタン クリック処理
    onClickLoginModalCancel() {
      this._modal = false
    },
    // パスワード登録処理
    onClickRegist() {
      // バリデーション
      this.validateRegistPassword = ''
      if (this.inputRegistPassword === '') this.validateRegistPassword = '登録するパスワードを入力してください。'
      if (this.validateRegistPassword !== '') return

      // API 登録処理
      this.postPassword(this.inputRegistPassword)
    },
    // パスワード登録処理
    async postPassword(password) {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.postPassword(password)
        .then(resp => {
          if (resp.status === 200) {
            alert('パスワード登録が完了しました。')
            this.settingFlg = 1
            this.$store.commit('User/setUserHasChiefPassword', 1)
          } else if (resp.status === 400) {
            this.validateRegistPassword = resp.data.body.message
          } else {
            alert('パスワード登録に失敗しました。')
            this._modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('パスワード登録に失敗しました。')
          this._modal = false
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パスワード変更処理
    onClickChange() {
      // バリデーション
      this.validateEditPassword = ''
      if (this.inputOldPassword === '' || this.inputNewPassword === '')
        this.validateEditPassword = 'パスワードを入力してください。'
      if (this.validateEditPassword !== '') return

      // API 登録処理
      this.putPassword(this.inputOldPassword, this.inputNewPassword)
    },
    // パスワード更新処理
    async putPassword(oldPassword, newPassword) {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.putPassword(oldPassword, newPassword)
        .then(resp => {
          if (resp.status === 200) {
            alert(resp.data.body.message)
            this.activeTab = 'auth'
            this.resetParams()
          } else if (resp.status === 400) {
            this.validateEditPassword = resp.data.body.message
          } else {
            alert('パスワード登録に失敗しました。')
            this._modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('パスワード更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメータをリセットする
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'
      this.inputPassword = ''
      this.inputOldPassword = ''
      this.inputNewPassword = ''
      this.inputRegistPassword = ''
      this.validatePassword = ''
      this.validateEditPassword = ''
      this.validateRegistPassword = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-password {
  .ivu-form-item-label {
    font-weight: bold;
  }

  .regist {
    .text {
      margin-bottom: 8px;
    }
  }
  .error {
    color: #ff0000;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>

<style lang="scss">
.modal-password {
  .ivu-form-item-label {
    font-weight: bold;
  }
}
</style>
